import { Modal } from "antd";
import React, { useState } from "react";

function DeletePicConfirmationModal({
  isModalVisible,
  handleOk,
  handleCancel,
  onDeleteConfirm,
  setEditProfileModal,
  setdeleteConfirmation,
  addUserFieldsData,
  fromUserProfile,
  setProfileDetails,
  userProfileDetails,type
}) {

  // console.log("modal", isModalVisible);
  const [deletePicLoader, setDeletePicLoader] = useState(false)
  const onOk = () => {
    setDeletePicLoader(true);
    onDeleteConfirm(() => setDeletePicLoader(false), () => {
      setEditProfileModal(false);
      setdeleteConfirmation(false);
      if (fromUserProfile && setProfileDetails) {
        setProfileDetails((prevDetails) => ({
          ...prevDetails,
          file: 'default.png',
          image: 'default.png',
        }));
      }
      if (!fromUserProfile && addUserFieldsData) {
        addUserFieldsData('file', '');
      }
    })
  }
  const confirmationMessage =
    type === "institute"
      ? "Are you sure you want to remove the institute logo?"
      : window.location.pathname === "/user-management/profile"
      ? "Are you sure want to remove the profile picture?"
      : "Are you sure you want to remove your profile picture?";
  return (
    <div>
      <Modal
        className="deleteUserModal"
        okText={"Yes"}
        cancelText={"No"}
        title="Basic Modal"
        visible={isModalVisible}
        onOk={() => onOk()}
        onCancel={handleCancel}
        okButtonProps={{ loading: deletePicLoader }}
      // okButtonProps={{ loading: true }}
      >
        <h2
          style={{
            fontFamily: "Roboto",
            textAlign: "center",
            color: "#594099",
            marginBottom: "0px",
            fontSize: "25px",
            fontWeight: "bold",
          }}
        >
          Confirm
        </h2>
        <p
          style={{
            fontFamily: "Roboto",
            textAlign: "center",
            color: "#636363",
          }}
        >
          {confirmationMessage}
        </p>
      </Modal>
    </div>
  );
}

export default DeletePicConfirmationModal;
